import { render, staticRenderFns } from "./SplitSelectorAntV.vue?vue&type=template&id=836d916a&scoped=true"
import script from "./SplitSelectorAntV.vue?vue&type=script&lang=js"
export * from "./SplitSelectorAntV.vue?vue&type=script&lang=js"
import style0 from "./SplitSelectorAntV.vue?vue&type=style&index=0&id=836d916a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "836d916a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\ideaWorkSpace\\zcy-dataEase\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('836d916a')) {
      api.createRecord('836d916a', component.options)
    } else {
      api.reload('836d916a', component.options)
    }
    module.hot.accept("./SplitSelectorAntV.vue?vue&type=template&id=836d916a&scoped=true", function () {
      api.rerender('836d916a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/chart/components/componentStyle/SplitSelectorAntV.vue"
export default component.exports